import {
  ActionTypeEnum,
  TagConditionScope,
} from '@dynamika-shared/types/pmTaskDefinitions';

export const ActionsTypeLabels = {
  [ActionTypeEnum.Function]: 'Function task',
  [ActionTypeEnum.Report]: 'Report task',
  [ActionTypeEnum.Scoring]: 'Scoring task',
};

export const actionsTypeOptions = Object.keys(ActionTypeEnum).map((key) => ({
  value: ActionTypeEnum[key as keyof typeof ActionTypeEnum],
  label: ActionsTypeLabels[ActionTypeEnum[key as keyof typeof ActionTypeEnum]],
}));

export const filterOptions = [
  {
    label: 'All',
    value: '.All',
  },
  {
    label: 'All of selection',
    value: '.IDs',
  },
  {
    label: 'Single value',
    value: '.ID',
  },
];

export const tagScopeOptions = [
  {
    label: 'Patient',
    value: TagConditionScope.PATIENT,
  },
  {
    label: 'Current Visit',
    value: TagConditionScope.CURRENT_VISIT,
  },
];
